import { render, staticRenderFns } from "./Upproval.vue?vue&type=template&id=55feca8a&"
import script from "./Upproval.vue?vue&type=script&lang=js&"
export * from "./Upproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports